import {
    RaikoBaseCardContainer,
    RaikoGridOneColumn,
    RaikoLabel,
    RaikoLabelType
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import DashboardWhiteItemContainer from "./DashboardWhiteItemContainer";
import DashboardWhiteItem from "./DashboardWhiteItem";
import {VowService} from "../../../serverService/vow/VowService";

export default function DashboardVowReports({vowId = 1}) {

    const vowService = new VowService();

    const [summaryPayStatus, setSummaryPayStatus] = useState({
        currentMonth: 0,
        currentWeek: 0,
        today: 0,
        total: 39200000,
    })

    useEffect(() => {
        vowService.getReport(vowId)
            .then(response => {
                setSummaryPayStatus({
                    currentMonth: response.currentMonth ? response.currentMonth : 0,
                    currentWeek: response.currentWeek ? response.currentWeek : 0,
                    today: response.today ? response.today : 0,
                    total: response.total ? response.total : 0
                })
            }).catch(reason => {

        }).finally(_ => {

        })
    }, []);


    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoLabel text={"خلاصه حمایت مالی"} raikoLabelType={RaikoLabelType.TITLE}/>
                <DashboardWhiteItemContainer>
                    <DashboardWhiteItem amount={summaryPayStatus.total} title={"مجموع کل"} colorIndex={4}/>
                    <DashboardWhiteItem amount={summaryPayStatus.currentMonth} title={"مجموع ماه"} colorIndex={1}/>
                    <DashboardWhiteItem amount={summaryPayStatus.currentWeek} title={"مجموع هفته"} colorIndex={2}/>
                    <DashboardWhiteItem amount={summaryPayStatus.today} title={"مجموع امروز"} colorIndex={3}/>
                </DashboardWhiteItemContainer>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}